const setPhoneMask = phone => phone.replace(/^(\d{3})(\d{3})(\d{2})(\d{2}).*/, '+7 ($1) $2-$3-$4')

export default setPhoneMask
